// extracted by mini-css-extract-plugin
export default {"mCard":"nA-z","image":"oA-z","imageNoBackground":"pA-z","imageHasCategory":"qA-z","fullWidth":"rA-z"};